import React, { useEffect, useState } from "react";
import {Col, Container, Row } from "react-bootstrap";
import PersonalComponent from "../components/inquary/PersonalComponent";
import AddressComponent from "../components/inquary/AddressComponent";
import SepaComponent from "../components/inquary/SepaComponent";
import SignatureComponent from "../components/inquary/SignatureComponent";
import PersonalIdComponent from "../components/inquary/PersonalIdComponent";
import DoneComponent from "../components/inquary/DoneComponent";
import Api from "../services/ApiService";
import AnlagenComponent from "../components/inquary/AnlagenComponent";
import ServerErrorComponent from "../components/inquary/ServerErrorComponent";
import IconContentCard from '../components/shared/IconContentCard';
import { BsDeviceSsd } from 'react-icons/bs';
import { FaUser, FaCheckCircle, FaPassport, FaFileSignature } from "react-icons/fa";
import { MdEditLocation, MdAccountBalance, MdError } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useAuthDispatch } from "../context/AuthContext";
import { GiPylon } from "react-icons/gi";
import ElvRegisterComponent from "../components/inquary/ElvRegisterComponent";


/**
 * InquaryPge - Registeration page
 * 
 * @url "/qr/registration"
 * 
 * @components "/components/inquary"
 * 
 * @returns None
 */

const InquaryPage = () => {

    const API = new Api(); // Api object for backend calls
    const dispatch = useAuthDispatch(); // use auth context to dispatch commands
    const navigate = useNavigate();
    const customer = JSON.parse(localStorage.getItem('customer')); // Get user object which was set on mail confirmation
    const [step, setStep] = useState(1); // integer for changing display of steps
    const [isLoading, setIsLoading] = useState(true);
    const [registrationDone, setRegistrationDone] = useState(false);

    const [apiError, setApiError] = useState("");

    const [data, setData] = useState();
    const [errors, setErrors] = useState({});


    // If step is equal to 6(last step) send data to backend
    useEffect(() => {
        if (customer === null) return navigate("/");
        
        if (data === undefined || Object.keys(data).length === 0) {
            setData({ 
                qr_code: customer.qr_code !== null? customer.qr_code : "",
                anlagen: [],
                case: customer.change_or_new,
                situation: customer.situation !== null? customer.situation : "",
                partner: {
                    company_type: customer.is_company? "company": "person",
                    noFn: false,
                    noVat: false,
                    x_firmenbuch_nr: "",
                    vat: '',
                    x_anrede: '',
                    title: '',
                    name: customer.first_name, 
                    lastName: customer.last_name,
                    x_title_postfix: '',
                    x_birthdate: '', 
                    email: customer.email,
                    mobile: customer.phone,
                    differentAddress: customer.qr_code !== null && customer.qr_code !== ""? false : true,
                    street: customer.address !== null? customer.address : "",
                    houseNr: customer.house_num !== null? customer.house_num : "",
                    stiege: "",
                    top: customer.qr_code !== null? customer.top : "",
                    zip: customer.zip !== null? customer.zip : "",
                    city: customer.city !== null? customer.city: "",
                    country_id: customer.country !== null? String(customer.country) : "12",
                    state_id: customer.state !== null? String(customer.state) : "",
                    
                    x_account_owner: customer.is_company? customer.first_name : `${customer.first_name} ${customer.last_name}`,
                    x_account_iban: '',
                    x_account_bic: '', 
        
                    x_file_vollmacht_readed: false,
                    x_file_vollmacht: '',
                    x_file_ausweiskopie: '',
                    x_file_ausweiskopie_name: "",
                    x_file_ausweiskopie_pdf: false,
                    x_qr_password: customer.password,        
                }
            });
        }

        if (step === 1) {
            if (customer.qr_code === null) setStep(2);
        }
        if (step === 6 && customer.is_company === true) {
            if (data.qr_code === "" || data.qr_code === null) {
                setStep(8); 
            } else {
                setStep(7);
            }
        }
        if (step === 7 && customer.qr_code === null) setStep(8);

        if (step === 8) {
            var cleanData = {...data};
            if (data.partner.x_file_ausweiskopie !== "" && data.partner.x_file_ausweiskopie.includes(',')) {
                cleanData.partner.x_file_ausweiskopie = data.partner.x_file_ausweiskopie.split(",")[1];
            }
            
            setIsLoading(true);
            
            API.register_complete(cleanData)
                .then(res => {
                    setIsLoading(false);
                    setRegistrationDone(true);
                    //localStorage.removeItem('customer');
                    let db_user = res.data.partner;
                    dispatch('LOGIN', db_user);
                    dispatch("TOOLTIPS_ON");
                    delete res.data['partner'];
                    localStorage.setItem('token', JSON.stringify(res.data));
                })
                .catch((err) => {
                    if (err.code === "ERR_NETWORK") {
                        setApiError("Keine Verbindung zum Server, versuchen sie später.");
                    } else {
                        if (err.response.data.detail !== undefined) {
                            setApiError(err.response.data.detail)
                        } else {
                            setApiError("Unbekanntes Fehler.")
                        }
                    }
                    setStep("!");
                    setIsLoading(false);
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [step])

    // Views
    return (
        <Container>
            <Row className="mt-5">
                <Col xs="12">
                    <h3><span className="text-energo">ENERGO</span> Registrierung</h3>
                </Col>
            </Row>
            <Row className="mt-5">
                <Col xs="12" className="mb-5">
                    <IconContentCard variant={step === "!"? 'error': null} icon={
                        step === "!" ? <MdError size={50} /> :
                        step === 1 ? <BsDeviceSsd size={50} /> : 
                        step === 2 ? <FaUser size={50} /> : 
                        step === 3 ? <MdEditLocation size={50} /> :
                        step === 4 ? <MdAccountBalance size={50} /> :
                        step === 5 ? <FaFileSignature size={50} /> :
                        step === 6 ? <FaPassport size={50} /> :
                        step === 7 ? <GiPylon size={50} /> :
                        step === 8 ? <FaCheckCircle size={50} /> : null
                    }>
                        {step === "!" ? <ServerErrorComponent data={data} error={apiError} setStep={setStep} /> : null}
                        {step === 1 ? <AnlagenComponent qr_code={customer?.qr_code} data={data} setData={setData} setStep={setStep} setError={setApiError} /> : null}
                        {step === 2 ? <PersonalComponent setStep={setStep} data={data} setData={setData} errors={errors} setErrors={setErrors} /> : null}
                        {step === 3 ? <AddressComponent setStep={setStep} data={data} setData={setData} errors={errors} setErrors={setErrors} /> : null}
                        {step === 4 ? <SepaComponent setStep={setStep} data={data} setData={setData} errors={errors} setErrors={setErrors} /> : null}
                        {step === 5 ? <SignatureComponent setStep={setStep} data={data} setData={setData} errors={errors} setErrors={setErrors} /> : null}
                        {step === 6 ? <PersonalIdComponent setStep={setStep} data={data} setData={setData} errors={errors} setErrors={setErrors} /> : null}
                        {step === 7 ? <ElvRegisterComponent setStep={setStep} data={data} setData={setData} errors={errors} setErrors={setErrors} /> :null}
                        {step === 8 ? <DoneComponent isLoading={isLoading} saveError={apiError} registrationDone={registrationDone} /> : null}
                    </IconContentCard>
                </Col>
            </Row>
        </Container>
    )
}

export default InquaryPage;